import _slicedToArray from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Button, ButtonLink } from "@/components/Buttons/index";
import { ProfilePasscodeForm } from "@/components/Form/index";
import ProfileIconImage from "@/components/Images/ProfileIconImage";
import Loading from "@/components/Loading";
import { useAccountSendProfilePinResetTokenMutation, useAuthSelectProfileMutation, useAuthUserQuery, useNotification, usePreviousPath, useRequireLogin } from "@/hooks";
import routes from "@/lib/routes";
import styles from "@/styles/Profile.module.scss";
import { useRouter } from "next/router";
import { useCallback, useEffect, useReducer } from "react";
import { PROFILE_MAX } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var initializeValue = {
  selectedProfile: null,
  passcodeInput: false,
  editProfileSelect: false
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "reset":
      return initializeValue;

    case "edit":
      return _objectSpread(_objectSpread({}, state), {}, {
        editProfileSelect: action.value
      });

    case "set":
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedProfile: action.profile,
        passcodeInput: action.profile.needPasscode
      });
  }
};

export default function SelectProfile(_ref) {
  var _user$currentProfile;

  var type = _ref.type,
      _ref$backToPrevPath = _ref.backToPrevPath,
      backToPrevPath = _ref$backToPrevPath === void 0 ? false : _ref$backToPrevPath;
  useRequireLogin();

  var _useNotification = useNotification(),
      showNotification = _useNotification.showNotification;

  var prevPath = usePreviousPath();
  var router = useRouter();

  var _useReducer = useReducer(reducer, initializeValue),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var _useAuthUserQuery = useAuthUserQuery(),
      user = _useAuthUserQuery.data.user;

  var _useAuthSelectProfile = useAuthSelectProfileMutation({
    onCompleted: function onCompleted() {
      if (type === "switch") {
        if (backToPrevPath) {
          window.location.href = prevPath || routes.home;
        } else {
          window.location.href = routes.home;
        }
      }
    },
    // update: (cache) => {
    //   cache.evict({ fieldName: "userFavorites" });
    //   cache.evict({ fieldName: "feavoritesByConentType" });
    //   cache.evict({ fieldName: "getViewingHistory" });
    //   cache.gc();
    // },
    onError: function onError(e) {
      return console.log(e);
    } // Uncaught Errorになるのでここでハンドリングする

  }),
      _useAuthSelectProfile2 = _slicedToArray(_useAuthSelectProfile, 2),
      select = _useAuthSelectProfile2[0],
      _useAuthSelectProfile3 = _useAuthSelectProfile2[1],
      selectProfileData = _useAuthSelectProfile3.data,
      loading = _useAuthSelectProfile3.loading,
      error = _useAuthSelectProfile3.error;

  useEffect(function () {
    if (type !== "switch" && user && user.profiles.length === 1) {
      var profile = user.profiles[0];

      if (profile.needPasscode) {
        dispatch({
          type: "set",
          profile: profile
        });
      } else {
        select({
          variables: {
            profileId: profile.id
          }
        });
      }
    }
  }, [type, user]);
  var handleClick = useCallback(function (profile) {
    return function () {
      if (state.editProfileSelect) {
        router.push(routes.profileEdit(profile.id));
      } else if (profile.needPasscode) {
        dispatch({
          type: "set",
          profile: profile
        });
      } else {
        select({
          variables: {
            profileId: profile.id
          }
        });
      }
    };
  }, [state.editProfileSelect]);
  var handleEdit = useCallback(function () {
    if (state.editProfileSelect) {
      dispatch({
        type: "edit",
        value: false
      });
    } else {
      dispatch({
        type: "edit",
        value: true
      });
    }
  }, [state.editProfileSelect]);

  var _useAccountSendProfil = useAccountSendProfilePinResetTokenMutation({
    onCompleted: function onCompleted(_ref2) {
      var sendProfilePinResetToken = _ref2.sendProfilePinResetToken;

      if (sendProfilePinResetToken !== null && sendProfilePinResetToken !== void 0 && sendProfilePinResetToken.result) {
        showNotification("暗証番号リセットメールをお送りしました", {
          time: 2000
        });
      }
    }
  }),
      _useAccountSendProfil2 = _slicedToArray(_useAccountSendProfil, 1),
      sendProfilePinResetToken = _useAccountSendProfil2[0];

  var resetPin = useCallback(function () {
    sendProfilePinResetToken();
  }, []);
  var handleBack = useCallback(function () {
    return dispatch({
      type: "reset"
    });
  }, []);
  var onSubmit = useCallback(function (data) {
    select({
      variables: {
        profileId: Number(data.id),
        passcode: data.passcode,
        type: "auth"
      }
    });
  }, []);
  var isOwner = user === null || user === void 0 ? void 0 : (_user$currentProfile = user.currentProfile) === null || _user$currentProfile === void 0 ? void 0 : _user$currentProfile.ownerProfile;
  if (selectProfileData) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.select,
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), !loading && state.passcodeInput && /*#__PURE__*/_jsx(ProfilePasscodeForm, {
      profile: state.selectedProfile,
      back: handleBack,
      onSubmit: onSubmit,
      error: error,
      resetPin: resetPin,
      type: "auth"
    }), !loading && !state.selectedProfile && !state.passcodeInput && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("h2", {
        children: [!state.editProfileSelect && "ご利用されるプロフィールを選択", state.editProfileSelect && "編集するプロフィールを選択してください。"]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.profiles,
        children: user && user.profiles.map(function (profile) {
          return /*#__PURE__*/_jsx("div", {
            className: styles.profileItem,
            children: /*#__PURE__*/_jsx(ProfileIconImage, _objectSpread(_objectSpread({}, profile), {}, {
              onClick: handleClick(profile)
            }))
          }, "profile-icon-".concat(profile.id));
        })
      }), type == "switch" && isOwner && /*#__PURE__*/_jsxs("div", {
        className: styles.btns,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.btn,
          children: /*#__PURE__*/_jsx(ButtonLink, {
            href: routes.profileAdd,
            borderGray: true,
            medium: true,
            disabled: user && user.profiles.length >= PROFILE_MAX,
            children: "\u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u306E\u8FFD\u52A0"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.btn,
          children: /*#__PURE__*/_jsxs(Button, {
            borderGray: true,
            medium: true,
            onClick: handleEdit,
            children: [state.editProfileSelect && "キャンセル", !state.editProfileSelect && "プロフィールの編集"]
          })
        })]
      })]
    })]
  });
}